export default __webpack_public_path__ + "static/media/react-logo.155e2725.png";